import { Theme } from '@mui/material';

export function divider(theme: Theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[200],
        },
      },
    },
  };
}
